import secondaryComponents from "../..";
import { PurchaseOrderImage } from "../../../../assets/svgImages";
import { RoutedModal, WarningDialog } from "../../../common";
import { POCategoriesForm } from "../POCatgoriesForm";
// import { WarningDialog } from "../../../common";
// import { usePOShareDialog } from "../POShareDialog/usePOShareDialog";
import { usePOCategoriesTable } from "./usePOCategoriesTable";

export const POCategoriesTable = ({
  pOCategories,
  metaDetails,
  gotoPage = () => {},
}) => {
  const {
    isDeletePOCategory,
    isUpdatePOCategory,
    instance,
    isDeleting,
    handleDeleteCategory,
    setIsUpdaePOCategory,
    setIsDeletePOCategory,
  } = usePOCategoriesTable({
    pOCategories,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  //   const { isDeletingPO, handleDeletePO } = usePOShareDialog({
  //     closeModal: () => setSelectedPODetails(null),
  //   });

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="pt-5 text-center">
          <PurchaseOrderImage />
          <h4>You have no PO Category</h4>
          <p>
            Use the button above to create PO Categories . When you do, they
            would appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {pOCategories?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={isDeletePOCategory !== null}
        width={550}
        closeModal={() => setIsDeletePOCategory(null)}
      >
        <WarningDialog
          title={"Delete Procurement Category"}
          closeModal={() => setIsDeletePOCategory(null)}
          handler={() => handleDeleteCategory()}
          isLoading={isDeleting}
        >
          <h5>Are you sure you want to delete this procurement category</h5>
          <p>
            Name: <span className="dark--text">{isDeletePOCategory?.name}</span>
          </p>
          <p>
            Description:{" "}
            <span className="dark--text">
              {isDeletePOCategory?.description || "N/A"}
            </span>
          </p>
        </WarningDialog>
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={isUpdatePOCategory !== null}
        closeModal={() => setIsUpdaePOCategory(null)}
        width={550}
        headerTitle="Update Procurement Category"
        style={{ height: "auto" }}
      >
        <POCategoriesForm
          closeModal={() => setIsUpdaePOCategory(null)}
          pOCategoryDetails={isUpdatePOCategory}
          isEditMode={true}
        />
      </RoutedModal>
    </>
  );
};
